import React from 'react';
import {
  PageTitle,
  PageName,
} from '@spaced-out/ui-design-system/lib/components/PageTitle';
import {selectBrandSettings} from '../../selectors/brandSelectors';
import {RootMachineContext} from '../../machines/rootMachine';
import {LanguageSupport} from 'src/components/settings/language-support.tsx';
import {RightSlot} from '@spaced-out/ui-design-system/lib/components/PageTitle/PageTitle';
import {selectLanguage} from '../../selectors/commonSelector.ts';

import css from './header.css';


export const Header = () => {
  const brandSettings = RootMachineContext.useSelector(selectBrandSettings);
  const actorRef = RootMachineContext.useActorRef();
  const currentLanguage = RootMachineContext.useSelector(selectLanguage);
  return (
    <PageTitle classNames={{wrapper: css.header}}>
      {brandSettings && (
        <PageName>
          <img
            className={css.logo}
            src={brandSettings?.logo}
            // eslint-disable-next-line @spaced-out/i18n/no-static-labels
            alt="agency logo"
          />
        </PageName>
      )}

      <RightSlot>
        <LanguageSupport
          language={currentLanguage}
          isExternalApp={true}
          onLanguageChange={(language) =>
            actorRef.send({type: 'language.update', language})
          }
        />
      </RightSlot>
    </PageTitle>
  );
};
